module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-36x36-d1c0ec92487f911db57337a57365c909.png";